import { call, fork, takeLatest, put, select } from "redux-saga/effects";
import { logoutUser } from "../actions/user/user.actions";
import * as actions from "../actions/invoice.actions";
import * as api from "../api/invoice.api";

function* getInvoices({ payload }) {
  try {
    const state = yield select();
    const response = yield call(
      api.getInvoices,
      state.user.userData.data.userId,
      payload
    );
    yield put(actions.getInvoicesSuccess(response.data));
  } catch (e) {
    if (e.response.status === 401) yield put(logoutUser());
    yield put(
      actions.invoiceError({
        error: "An error occurred when trying to get invoices"
      })
    );
  }
}

function* watchGetInvoicesRequest() {
  yield takeLatest(actions.Types.GET_INVOICES, getInvoices);
}

function* getInvoiceTypes() {
  try {
    const response = yield call(api.getInvoiceTypes);
    yield put(actions.getInvoiceTypesSuccess(response.data));
  } catch (e) {
    if (e.response.status === 401) yield put(logoutUser());
    yield put(
      actions.invoiceError({
        error: "An error occurred when trying to get invoice types"
      })
    );
  }
}

function* watchGetInvoiceTypesRequest() {
  yield takeLatest(actions.Types.GET_INVOICE_TYPES, getInvoiceTypes);
}

function* getInvoicePdf({ payload }) {
  try {
    const state = yield select();
    const response = yield call(
      api.getInvoicePdf,
      state.user.userData.data.userId,
      payload.invoiceId
    );

    const file = new Blob([response.data], { type: "application/pdf" });
    const pdfURL = window.URL.createObjectURL(file);
    let fileLink = document.createElement("a");
    fileLink.href = pdfURL;
    fileLink.download = `Invoice-${payload.invoiceId}.pdf`;
    document.body.appendChild(fileLink);
    fileLink.click();

    setTimeout(() => {
      document.body.removeChild(fileLink);
      window.URL.revokeObjectURL(pdfURL);
    }, 100);

    yield put(actions.getInvoicePdfSuccess(payload.invoiceId));
  } catch (e) {
    if (e.response.status === 401) yield put(logoutUser());
    yield put(
      actions.invoiceError({
        error: "An error occurred when trying to get invoices"
      })
    );
  }
}

function* watchGetInvoicePDFRequest() {
  yield takeLatest(actions.Types.GET_INVOICE_PDF, getInvoicePdf);
}

function* markInvoicePayed({ payload }) {
  const state = yield select();
  yield call(
    api.markInvoiceAsPayed,
    state.user.userData.data.userId,
    payload.ShoppingCartId,
    payload.WsPayOrderId
  );
  yield call(getInvoices);
}

function* watchMarkInvoicePayed() {
  yield takeLatest(actions.Types.MARK_INVOICE_PAYED, markInvoicePayed);
}

export default [
  fork(watchGetInvoicesRequest),
  fork(watchGetInvoicePDFRequest),
  fork(watchMarkInvoicePayed),
  fork(watchGetInvoiceTypesRequest)
];
